export const completedStatusId = 5;

export const acceptanceParentServiceId = 2785;

export const calendarTypeIds = {
  acceptance: 2,
  common: 1,
};

export const defaultRequestDateMode = 1;
